import React, {useContext} from 'react';
import {Card, ListGroup, Dropdown} from 'react-bootstrap';
import moment from 'moment-timezone';
import {MDBCheckbox} from 'mdb-react-ui-kit';
import DatePicker from 'react-datepicker';
import {FontAwesomeIcon} from '@fortawesome/react-fontawesome';
import {faTrash} from '@fortawesome/free-solid-svg-icons';
import {MadricContext} from '../../../Context/MadricContext';

/**
 * La vue du checkin
 * @param {*} props props
 * @return {JSX}
 */
function ChantierInfoCheckin(props) {
  const {listeEmploye} = useContext(MadricContext);

  const formatDate = (dateString) => {
    const date = moment.tz(dateString, 'America/Montreal');
    const dayNames = {
      Monday: 'Lundi',
      Tuesday: 'Mardi',
      Wednesday: 'Mercredi',
      Thursday: 'Jeudi',
      Friday: 'Vendredi',
      Saturday: 'Samedi',
      Sunday: 'Dimanche',
    };
    moment.locale('fr'); // set locale to French
    const dayName = dayNames[date.format('dddd')];
    return `${dayName} le ${date.format('DD-MM-YYYY')}`;
  };

  return (
    <React.Fragment>

      <div className="chantierheure-filter-container">


        <Dropdown >
          <Dropdown.Toggle
            className="chantierheure-form-control"
            style={{
              backgroundColor: 'white',
              marginTop: '0px',
              marginLeft: '0px',
              color: 'black',
              height: '47px',
              border: '2px solid black',
            }}>
            {props.inputRef.label}
          </Dropdown.Toggle>
          <Dropdown.Menu>
            {listeEmploye.map((user, index) => {
              return <Dropdown.Item key={index} onClick={() => props.handleChange(user)}>{user.label}</Dropdown.Item>;
            })}
          </Dropdown.Menu>
        </Dropdown>

        <DatePicker
          className="chantierheure-form-control"
          type="date"
          selected={props.dateRef}
          onChange={props.handleDateChange}
          placeholderText="Filtrer par date"
          dateFormat="dd-MM-yyyy" />
        <FontAwesomeIcon
          className="chantierheure-trash-icon"
          icon={faTrash}
          onClick={() => props.removeDate()} />
      </div>
      <div className="chantierheure-filter-container">
        <DatePicker
          className="chantierheure-form-control2"
          type="text"
          selected={props.dateRef}
          onChange={props.handleDateChange}
          placeholderText="Filtrer par date"
          dateFormat="dd-MM-yyyy" />
        <FontAwesomeIcon
          className="chantierheure-trash-icon2"
          icon={faTrash}
          onClick={() => props.removeDate()} />
      </div>

      <div style={{marginBottom: '40px'}}>
        <MDBCheckbox name='extra1' label='Extra possible' inline onChange={props.handleCheckboxChange}/>
        {localStorage.getItem('admin') === '1' ?
            <React.Fragment>
              <MDBCheckbox name='extra2' label='Extra valider' inline onChange={props.handleCheckboxChange} />
              <MDBCheckbox name='extra3' label='Extra confirmer' inline onChange={props.handleCheckboxChange}/>
            </React.Fragment> : '' }
      </div>
      {props.filteredCheckin.map((checkin, index) => (
        <div className="checkin-container" key={checkin.id}>
          <Card className="checkin-card">
            <Card.Header className="checkin-header">{formatDate(checkin.date)}

            </Card.Header>
            <ListGroup variant="flush">
              <ListGroup.Item className="checkin-list-item">Employé: {checkin.user_name}</ListGroup.Item>
              <ListGroup.Item className="checkin-list-item"
                style={{backgroundColor: checkin.from === null || checkin.to === null ? 'red' : 'white'}}>
            Heure: {checkin.from === null ? '-' : checkin.from} à {checkin.to === null ? '-' : checkin.to}
              </ListGroup.Item>
              <ListGroup.Item className="checkin-list-item">Transport: {checkin.transport === 1 ? 'Oui' : 'Non'}</ListGroup.Item>
              <ListGroup.Item className="checkin-list-item">Travaillé avec:
                {checkin.work_with.length === 0 ? (
                      ' Aucun employé'
                    ) : (
                      <Dropdown>
                        <Dropdown.Toggle
                          className="chantierheure-dropdown"
                          style={{
                            all: 'unset',
                            backgroundColor: 'white',
                            color: 'black',
                            cursor: 'pointer',
                          }}>
                          {checkin.work_with[0].label}
                        </Dropdown.Toggle>
                        <Dropdown.Menu>
                          {checkin.work_with.map((w, index) => {
                            return <Dropdown.Item key={index}>{w.label}</Dropdown.Item>;
                          })}
                        </Dropdown.Menu>
                      </Dropdown>
                    )}
              </ListGroup.Item>
              <ListGroup.Item>
                <MDBCheckbox name='inlineCheck' id='inlineCheckbox111' checked={checkin.extra1} label='Extra possible' disabled inline />
                {localStorage.getItem('admin') === '1' ?
            <React.Fragment>
              <MDBCheckbox name='inlineCheck' id='inlineCheckbox222' checked={checkin.extra2} label='Extra valider' disabled inline />
              <MDBCheckbox name='inlineCheck' id='inlineCheckbox333' checked={checkin.extra3} label='Extra confirmer' disabled inline />
            </React.Fragment> : ' ' }

              </ListGroup.Item>
              <ListGroup.Item className="checkin-list-item">Note: {checkin.note}</ListGroup.Item>
            </ListGroup>

          </Card>
        </div>
      ))}


    </React.Fragment>
  );
}

export default ChantierInfoCheckin;
